import { IAutomationObject } from "../../types";
import { AutomationObjectCard } from "./AutomationObjectCard";
import { useMemo } from "react";
import { FlexGridView } from "./FlexGridView";


export function AutomationObjectsFlexGridView(props: { items: IAutomationObject[], flexGridColumnCount?: any, additionalState?: any, small?: boolean, noSort?: boolean }) {
    const sortedItems = useMemo(() => props.items ? (props.noSort ? props.items : [...props.items].sort((a, b) => a.description?.localeCompare(b.description))) : [], [props.items]);
    return (
        <FlexGridView  flexGridColumnCount={props.flexGridColumnCount} >
            {sortedItems?.map((item: any, index: number) => (
                <AutomationObjectCard key={item.id} small={props.small} item={item} additionalProps={props.additionalState}></AutomationObjectCard>
            ))}
        </FlexGridView>

    )
}